import {
  InputLabel,
  Stack,
  Tooltip,
  Box,
  SxProps,
  useTheme,
} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

export interface IBaseLabelProps {
  hint?: React.ReactNode | string;
  required?: boolean;
  sx?: SxProps;
}

interface IFormTitleProps extends IBaseLabelProps {
  title?: string;
  showTitle?: boolean;
}

interface IFieldLabelProps extends IBaseLabelProps {
  label: string;
}

export const FormTitle = (props: IFormTitleProps) => {
  const { title = "", showTitle = true, hint, required, sx } = props;
  if (!showTitle || title === "") return <></>;
  return (
    <InputLabel shrink={true} sx={sx}>
      <Stack
        sx={{
          justifyContent: "space-between",
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <FieldLabel label={title} hint={hint} required={required} />
      </Stack>
    </InputLabel>
  );
};

export const FieldLabel = (props: IFieldLabelProps) => {
  const { label, hint, required, sx } = props;

  return (
    <Stack direction="row" sx={{ justifyContent: "space-between", ...sx }}>
      <Box sx={{ display: "inline-block" }}>
        {required ? <span className="MuiFormLabel-asterisk">*</span> : null}
        <span>{label}</span>
        <FieldLabelHint hint={hint} />
      </Box>
    </Stack>
  );
};

export function FieldLabelHint({ hint }: any) {
  const { palette } = useTheme();

  if (!hint) return null;

  return (
    <Tooltip placement="right" title={<Box fontSize="small">{hint}</Box>}>
      <InfoOutlinedIcon
        fontSize="small"
        sx={{
          mt: "-4px",
          ml: 0.25,
          p: 0.25,
          transform: "translateY(20%)",
          borderRadius: "50%",
          cursor: "default",
          "&:hover": { backgroundColor: palette.action.hover },
        }}
      />
    </Tooltip>
  );
}
